import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b2e69fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal-backdrop"
}
const _hoisted_2 = { class: "modal2" }
const _hoisted_3 = { class: "modal-header flex-row flex-align-center" }
const _hoisted_4 = { class: "text-center flex-1 modal-header-title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#333",
    d: "M14 12.461 8.3 6.772l5.234-5.233L12.006 0 6.772 5.234 1.54 0 0 1.539l5.234 5.233L0 12.006l1.539 1.528L6.772 8.3l5.69 5.7L14 12.461z"
  })
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "modal-body flex-row flex-wrap" }
const _hoisted_8 = { class: "table table-borderless" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { style: {"width":"100px"} }),
  /*#__PURE__*/_createElementVNode("td")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", { for: "class-title" }, "标题:")
  ])
], -1))
const _hoisted_11 = { class: "mb-1" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", { for: "class-order" }, "排序:")
  ])
], -1))
const _hoisted_13 = { class: "mb-1" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", null, "推荐:")
  ])
], -1))
const _hoisted_16 = { class: "mb-1 form-switch" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", { for: "class-show" }, "状态:")
  ])
], -1))
const _hoisted_18 = { class: "mb-1 form-switch" }
const _hoisted_19 = { class: "modal-footer2 flex-row-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.label.id ? '编辑' : '添加'), 1),
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args))),
              class: "modal-header-close"
            }, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("table", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("tr", null, [
                _hoisted_10,
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_11, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.label.title) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.label.title]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_12,
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_13, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.label.order) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.label.order]
                    ])
                  ])
                ])
              ]),
              (_ctx.hasRecommend)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_16, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          checked: "",
                          type: "checkbox",
                          role: "switch",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.label.recommend) = $event))
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.label.recommend]
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("tr", null, [
                _hoisted_17,
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_18, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      checked: "",
                      type: "checkbox",
                      role: "switch",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.label.show) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.label.show]
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
            }, "确定")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}